export const enum ViewType {
  List = 'list',
  Tiles = 'tiles',
  Map = 'map',
}
